import { Link } from "react-router-dom";
import { Book, Compass } from "lucide-react";

export const NavigationMenuItems = () => {
  const menuItems = [
    {
      title: "Blog",
      description: "Read about the best private dining spots in NYC",
      icon: <Book className="w-4 h-4" />,
      href: "/blog"
    }
  ];

  return (
    <div className="w-[300px] p-4">
      <div className="grid gap-2">
        <div className="flex items-center gap-2 px-2 py-1.5">
          <Compass className="w-4 h-4 text-secondary" />
          <span className="text-sm font-medium">Discover NYC Venues</span>
        </div>
        <div className="grid gap-1">
          {menuItems.map((item) => (
            <Link
              key={item.title}
              to={item.href}
              className="flex items-start gap-4 rounded-lg p-3 text-left transition-colors hover:bg-accent"
            >
              <div className="flex h-8 w-8 items-center justify-center rounded-md border bg-background">
                {item.icon}
              </div>
              <div>
                <div className="text-sm font-medium leading-none mb-1">
                  {item.title}
                </div>
                <p className="line-clamp-2 text-sm text-muted-foreground">
                  {item.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};